import { useState } from "react";
import { getBooks, getSpeakers, getYears } from "./data";
import Select from 'react-select';

export default function Filters({ filters, setFilters }) {
	const [speakers] = useState(getSpeakers)
	const [years] = useState(getYears)
	const [books] = useState(getBooks)

	const handleFilterChange = (key, value) => {
		const newFilters = { ...filters }
		if(!value) {
			delete newFilters[key]
		} else {
			newFilters[key] = value
		}
		setFilters(newFilters)
	}

	const sharedSelectProps = {
		isMulti: true,
		className: "filter",
		classNamePrefix: "gil-select",
		styles: {
			input: (base) => ({ ...base, fontSize: '14px' }),
			placeholder: (base) => ({ ...base, fontSize: '14px' }),
			option: (base) => ({ ...base, fontSize: '14px' }),
			control: (base) => ({ ...base, borderRadius: 0, border: 'none' }),
			multiValueLabel: (base) => ({ ...base, fontSize: '14px' })
		}
	}

	return (
		<div className="filters">
			<div className="filters--group" onTouchEndCapture={(e) => e.stopPropagation()}>
				<label>Speaker</label>
				<Select
					{...sharedSelectProps}
					options={speakers.map(speaker => ({ value: speaker, label: speaker }))}
					value={filters.speaker ? filters.speaker.map(speaker => ({ value: speaker, label: speaker })) : []}
					onChange={selected => handleFilterChange('speaker', selected.map(s => s.value))}
				/>
			</div>
			<div className="filters--group" onTouchEndCapture={(e) => e.stopPropagation()}>
				<label>Year</label>
				<Select
					{...sharedSelectProps}
					options={years.map(year => ({ value: year, label: year }))}
					value={filters.year ? filters.year.map(year => ({ value: year, label: year })) : []}
					onChange={selected => handleFilterChange('year', selected.map(s => s.value))}
				/>
			</div>
			<div className="filters--group" onTouchEndCapture={(e) => e.stopPropagation()}>
				<label>Book</label>
				<Select
					{...sharedSelectProps}
					options={books.map(book => ({ value: book, label: book }))}
					value={filters.book ? filters.book.map(book => ({ value: book, label: book })) : []}
					onChange={selected => handleFilterChange('book', selected.map(s => s.value))}
				/>
			</div>
		</div>
	)
}
